export const CLEAR_AD_CAMPAIGN = 'CLEAR_AD_CAMPAIGN'
export const clearAdCampaign = () => ({ type: CLEAR_AD_CAMPAIGN })

export const GET_PAID_ADS = 'GET_PAID_ADS'
export const GET_PAID_ADS_FULFILLED = 'GET_PAID_ADS_FULFILLED'
export const GET_PAID_ADS_REJECTED = 'GET_PAID_ADS_REJECTED'
/**
 * Trigger epic to get paid ads
 * @param {{retailerIds: number[]}} payload
 */
export const getPaidAds = (payload) => ({ type: GET_PAID_ADS, payload })

export const GET_AD_CAMPAIGN = 'GET_AD_CAMPAIGN'
export const GET_AD_CAMPAIGN_FULFILLED = 'GET_AD_CAMPAIGN_FULFILLED'
export const GET_AD_CAMPAIGN_REJECTED = 'GET_AD_CAMPAIGN_REJECTED'

/**
 * @typedef {object} GetAdCampaignPayload
 * @property {string} campaignId - ID of the brand
 * @property {number} brandId - ID of the brand
 */
/**
 * Get an Ad-Campaign
 * @param {GetAdCampaignPayload} payload
 */
export const getAdCampaign = (payload) => ({ type: GET_AD_CAMPAIGN, payload })

export const CREATE_AD_CAMPAIGN = 'CREATE_AD_CAMPAIGN'
export const CREATE_AD_CAMPAIGN_FULFILLED = 'CREATE_AD_CAMPAIGN_FULFILLED'
export const CREATE_AD_CAMPAIGN_REJECTED = 'CREATE_AD_CAMPAIGN_REJECTED'

/**
 * Data object for Ad-Campaign
 * @typedef {object} CreateAdCampaignData
 * @property {string} brand_id - brand id
 * @property {string} starts_at - start date of the campaign
 * @property {string} ends_at - end adte of the campaign
 * @property {string} objective - ad objective
 * @property {string} state - draft or published
 * @property {string[]} channels - brand id
 */
/**
 * @typedef {object} CreateAdCampaignPayload
 * @property {CreateAdCampaignData} data - create ad-campaign data
 * @property {string} auth - jwt auth
 */
/**
 * Create an Ad-Campaign
 * @param {CreateAdCampaignPayload} payload
 */
export const createAdCampaign = (payload) => ({
  type: CREATE_AD_CAMPAIGN,
  payload,
})

export const UPDATE_AD_CAMPAIGN = 'UPDATE_AD_CAMPAIGN'
export const UPDATE_AD_CAMPAIGN_FULFILLED = 'UPDATE_AD_CAMPAIGN_FULFILLED'
export const UPDATE_AD_CAMPAIGN_REJECTED = 'UPDATE_AD_CAMPAIGN_REJECTED'

/**
 * Data object for Ad-Campaign
 * @typedef {object} UpdateAdCampaignData
 * @property {string} brand_id - brand id
 * @property {string} starts_at - start date of the campaign
 * @property {string} ends_at - end adte of the campaign
 * @property {string} objective - ad objective
 * @property {string} state - draft or published
 * @property {string[]} channels - brand id
 */
/**
 * @typedef {object} UpdateAdCampaignPayload
 * @property {UpdateAdCampaignData} data - update ad-campaign data
 * @property {string} auth - jwt auth
 * @property {number} brandId - Brand ID
 * @property {string} camapignId - Camapign ID
 */
/**
 * Update an Ad-Campaign
 * @param {UpdateAdCampaignPayload} payload
 */
export const updateAdCampaign = (payload) => ({
  type: UPDATE_AD_CAMPAIGN,
  payload,
})

export const POST_AD_CAMPAIGN_INVITATIONS = 'POST_AD_CAMPAIGN_INVITATIONS'
export const POST_AD_CAMPAIGN_INVITATIONS_FULFILLED =
  'POST_AD_CAMPAIGN_INVITATIONS_FULFILLED'
export const POST_AD_CAMPAIGN_INVITATIONS_REJECTED =
  'POST_AD_CAMPAIGN_INVITATIONS_REJECTED'

/**
 * Data object for Ad-Campaign
 * @typedef {object} RetailerInvitationData
 * @property {string} channel_campaign_id - id of the channel the campaign is associated to
 * @property {{id:string, amount_cents:string}} retailers - list of invited retailers
 */
/**
 * @typedef {object} PostAdCampaignInvitationsPayload
 * @property {RetailerInvitationData} data - invitation data
 * @property {string} auth - jwt auth
 */
/**
 * Publish Ad-Campaign
 * @param {PostAdCampaignInvitationsPayload} payload
 */
export const postAdCampaignInvitations = (payload) => ({
  type: POST_AD_CAMPAIGN_INVITATIONS,
  payload,
})

export const PUBLISH_AD_CAMPAIGN = 'PUBLISH_AD_CAMPAIGN'
export const PUBLISH_AD_CAMPAIGN_FULFILLED = 'PUBLISH_AD_CAMPAIGN_FULFILLED'
export const PUBLISH_AD_CAMPAIGN_REJECTED = 'PUBLISH_AD_CAMPAIGN_REJECTED'

/**
 * @typedef {object} PublishAdCampaignPayload
 * @property {string} campaign_id - campaign id of campaign thats being published
 * @property {string} auth - jwt auth
 */
/**
 * Publish Ad-Campaign
 * @param {PublishAdCampaignPayload} payload
 */
export const publishAdCampaign = (payload) => ({
  type: PUBLISH_AD_CAMPAIGN,
  payload,
})

/**
 * @typedef {object} DeleteAdCampaignInvitationsPayload
 * @property {string} brandId - brand id which the ad campaign belongs to
 * @property {string} campaignId - ad campaign id to delete the invitations from
 */
/**
 * Delete Ad-Campaign Invitations
 * @param {DeleteAdCampaignInvitationsPayload} payload
 */
export const DELETE_AD_CAMPAIGN_INVITATIONS = 'DELETE_AD_CAMPAIGN_INVITATIONS'
export const DELETE_AD_CAMPAIGN_INVITATIONS_FULFILLED =
  'DELETE_AD_CAMPAIGN_INVITATIONS_FULFILLED'
export const DELETE_AD_CAMPAIGN_INVITATIONS_REJECTED =
  'DELETE_AD_CAMPAIGN_INVITATIONS_REJECTED'

export const deleteAdCampaignInvitations = (payload) => ({
  type: DELETE_AD_CAMPAIGN_INVITATIONS,
  payload,
})

/**
 * @typedef {object} DeleteAdCampaignPayload
 * @property {string} brandId - brand id which the ad campaign belongs to
 * @property {string} campaignId - ad campaign id to delete the invitations from
 */
/**
 * Delete Ad-Campaign
 * @param {DeleteAdCampaignPayload} payload
 */
export const DELETE_AD_CAMPAIGN = 'DELETE_AD_CAMPAIGN'
export const DELETE_AD_CAMPAIGN_FULFILLED = 'DELETE_AD_CAMPAIGN_FULFILLED'
export const DELETE_AD_CAMPAIGN_REJECTED = 'DELETE_AD_CAMPAIGN_REJECTED'

export const deleteAdCampaign = (payload) => ({
  type: DELETE_AD_CAMPAIGN,
  payload,
})
